import './ArtistModal.scss';

import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useCurrentUser } from '../../../UserProvider';
import classNames from 'classnames';
import { api } from '../../../utils/api';

export default function ContactModal({ show, handleClose, artist }) {
  const { currentUser } = useCurrentUser();

  const [email, setEmail] = useState("");
  const [text, setText] = useState("");
  const [enableSend, setEnableSend] = useState(false);

  const handleSend = async () => {
    const payload = {
      receiver_id: artist.user_id,
      text
    };
    if (!currentUser) {
      payload['sender_email'] = email;
    }
    api.post(`/direct_messages`, payload);

    handleClose();
  };

  useEffect(() => {
    if (currentUser) {
      setEnableSend(Boolean(text && text.trim() !== ""));
    } else {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
      setEnableSend(isValidEmail && Boolean(text && text.trim() !== ""));
    }
  }, [currentUser, email, text]);

  return (
    <Modal className='__artist-modal' show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Contact Me</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          Send a direct message to { artist.name ? artist.name : artist.display_name }
        </div>
        <Form>
          { !currentUser &&
            <Form.Group className="mb-3">
              <Form.Label>Your Email</Form.Label>
              <Form.Control
                value={ email }
                onChange={ (e) => setEmail(e.target.value) }
              />
            </Form.Group>
          }

          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={ 4 }
              value={ text }
              onChange={ (e) => setText(e.target.value) }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className={ classNames(['ppy-btn', 'ppy-btn-primary', { disabled: !enableSend }]) } onClick={ handleSend }>Send</Button>
      </Modal.Footer>
    </Modal>
  );
}
